import { useEffect } from 'react';

/** The favicon uses the same logo3.svg geometry as CordeLogo. */
const mark = '<circle cx="256" cy="256" r="160"/><path d="M224 64v384M288 64v384M64 224h384M64 288h384"/>';

export function ThemeFavicon() {
  useEffect(() => {
    const root = document.documentElement;
    const link = document.querySelector<HTMLLinkElement>('#corde-favicon');
    if (!link) return;

    let frame = 0;
    let previousColor = '';
    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const primary = getComputedStyle(root).getPropertyValue('--primary').trim();
        const color = primary ? `hsl(${primary})` : 'hsl(222.2 47.4% 11.2%)';
        if (color === previousColor) return;
        previousColor = color;
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="none" stroke="${color}" stroke-width="28" stroke-linecap="round">${mark}</svg>`;
        link.href = `data:image/svg+xml,${encodeURIComponent(svg)}`;
      });
    };

    update();
    const observer = new MutationObserver(update);
    observer.observe(root, { attributes: true, attributeFilter: ['class', 'style'] });
    const scheme = window.matchMedia('(prefers-color-scheme: dark)');
    scheme.addEventListener('change', update);
    return () => {
      observer.disconnect();
      scheme.removeEventListener('change', update);
      cancelAnimationFrame(frame);
    };
  }, []);

  return null;
}
